import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'atlas-api.vendasta-local.com',
  'test': '',
  'demo': 'atlas-api-demo.apigateway.co',
  'prod': 'atlas-api-prod.apigateway.co',
  'production': 'atlas-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var PlatformMode = /*#__PURE__*/function (PlatformMode) {
  PlatformMode[PlatformMode["WEB"] = 0] = "WEB";
  PlatformMode[PlatformMode["MOBILE"] = 1] = "MOBILE";
  return PlatformMode;
}(PlatformMode || {});
var UITheme = /*#__PURE__*/function (UITheme) {
  UITheme[UITheme["UI_THEME_DARK"] = 0] = "UI_THEME_DARK";
  UITheme[UITheme["UI_THEME_LIGHT"] = 1] = "UI_THEME_LIGHT";
  UITheme[UITheme["UI_THEME_USER_PREFERENCE"] = 2] = "UI_THEME_USER_PREFERENCE";
  return UITheme;
}(UITheme || {});
var UserViewType = /*#__PURE__*/function (UserViewType) {
  UserViewType[UserViewType["USER_VIEW_TYPE_SMB"] = 0] = "USER_VIEW_TYPE_SMB";
  UserViewType[UserViewType["USER_VIEW_TYPE_ADMIN"] = 1] = "USER_VIEW_TYPE_ADMIN";
  return UserViewType;
}(UserViewType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccountGroup {
  static fromProto(proto) {
    let m = new AccountGroup();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.activatedProductIds !== 'undefined') {
      toReturn['activatedProductIds'] = this.activatedProductIds;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class GetLocationsRequestAccountGroups {
  static fromProto(proto) {
    let m = new GetLocationsRequestAccountGroups();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    return toReturn;
  }
}
class AssociatedLocationIDs {
  static fromProto(proto) {
    let m = new AssociatedLocationIDs();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    if (typeof this.groupPaths !== 'undefined') {
      toReturn['groupPaths'] = this.groupPaths;
    }
    return toReturn;
  }
}
class Brand {
  static fromProto(proto) {
    let m = new Brand();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.pathNodes !== 'undefined') {
      toReturn['pathNodes'] = this.pathNodes;
    }
    if (typeof this.hasAccess !== 'undefined') {
      toReturn['hasAccess'] = this.hasAccess;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class Branding {
  static fromProto(proto) {
    let m = new Branding();
    m = Object.assign(m, proto);
    if (proto.theme) {
      m.theme = enumStringToValue(UITheme, proto.theme);
    }
    if (proto.theming) {
      m.theming = Theming.fromProto(proto.theming);
    }
    if (proto.businessAppUiTheme) {
      m.businessAppUiTheme = enumStringToValue(UITheme, proto.businessAppUiTheme);
    }
    if (proto.exitLinkConfiguration) {
      m.exitLinkConfiguration = ExitLinkConfiguration.fromProto(proto.exitLinkConfiguration);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.theme !== 'undefined') {
      toReturn['theme'] = this.theme;
    }
    if (typeof this.logoUrl !== 'undefined') {
      toReturn['logoUrl'] = this.logoUrl;
    }
    if (typeof this.partnerName !== 'undefined') {
      toReturn['partnerName'] = this.partnerName;
    }
    if (typeof this.centerName !== 'undefined') {
      toReturn['centerName'] = this.centerName;
    }
    if (typeof this.theming !== 'undefined' && this.theming !== null) {
      toReturn['theming'] = 'toApiJson' in this.theming ? this.theming.toApiJson() : this.theming;
    }
    if (typeof this.cobrandingLogoUrl !== 'undefined') {
      toReturn['cobrandingLogoUrl'] = this.cobrandingLogoUrl;
    }
    if (typeof this.marketName !== 'undefined') {
      toReturn['marketName'] = this.marketName;
    }
    if (typeof this.darkModeLogoUrl !== 'undefined') {
      toReturn['darkModeLogoUrl'] = this.darkModeLogoUrl;
    }
    if (typeof this.businessAppUiTheme !== 'undefined') {
      toReturn['businessAppUiTheme'] = this.businessAppUiTheme;
    }
    if (typeof this.exitLinkConfiguration !== 'undefined' && this.exitLinkConfiguration !== null) {
      toReturn['exitLinkConfiguration'] = 'toApiJson' in this.exitLinkConfiguration ? this.exitLinkConfiguration.toApiJson() : this.exitLinkConfiguration;
    }
    return toReturn;
  }
}
class CenterNavigationItem {
  static fromProto(proto) {
    let m = new CenterNavigationItem();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.entryUrl !== 'undefined') {
      toReturn['entryUrl'] = this.entryUrl;
    }
    if (typeof this.centerId !== 'undefined') {
      toReturn['centerId'] = this.centerId;
    }
    return toReturn;
  }
}
class ContactUsRequest {
  static fromProto(proto) {
    let m = new ContactUsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    return toReturn;
  }
}
class DropdownItem {
  static fromProto(proto) {
    let m = new DropdownItem();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.path !== 'undefined') {
      toReturn['path'] = this.path;
    }
    if (typeof this.translationId !== 'undefined') {
      toReturn['translationId'] = this.translationId;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    return toReturn;
  }
}
class ExitLinkConfiguration {
  static fromProto(proto) {
    let m = new ExitLinkConfiguration();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.exitLinkText !== 'undefined') {
      toReturn['exitLinkText'] = this.exitLinkText;
    }
    if (typeof this.exitLinkUrl !== 'undefined') {
      toReturn['exitLinkUrl'] = this.exitLinkUrl;
    }
    return toReturn;
  }
}
class GetDataRequest {
  static fromProto(proto) {
    let m = new GetDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.signOutNextUrl !== 'undefined') {
      toReturn['signOutNextUrl'] = this.signOutNextUrl;
    }
    if (typeof this.groupPath !== 'undefined') {
      toReturn['groupPath'] = this.groupPath;
    }
    return toReturn;
  }
}
class GetDataResponse {
  static fromProto(proto) {
    let m = new GetDataResponse();
    m = Object.assign(m, proto);
    if (proto.user) {
      m.user = proto.user.map(UserNavigationItem.fromProto);
    }
    if (proto.centers) {
      m.centers = proto.centers.map(CenterNavigationItem.fromProto);
    }
    if (proto.theme) {
      m.theme = enumStringToValue(UITheme, proto.theme);
    }
    if (proto.theming) {
      m.theming = Theming.fromProto(proto.theming);
    }
    if (proto.locationData) {
      m.locationData = LocationData.fromProto(proto.locationData);
    }
    if (proto.userSwitcherData) {
      m.userSwitcherData = proto.userSwitcherData.map(UserSwitcherData.fromProto);
    }
    if (proto.businessAppUiTheme) {
      m.businessAppUiTheme = enumStringToValue(UITheme, proto.businessAppUiTheme);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.user !== 'undefined' && this.user !== null) {
      toReturn['user'] = 'toApiJson' in this.user ? this.user.toApiJson() : this.user;
    }
    if (typeof this.centers !== 'undefined' && this.centers !== null) {
      toReturn['centers'] = 'toApiJson' in this.centers ? this.centers.toApiJson() : this.centers;
    }
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.signOutUrl !== 'undefined') {
      toReturn['signOutUrl'] = this.signOutUrl;
    }
    if (typeof this.theme !== 'undefined') {
      toReturn['theme'] = this.theme;
    }
    if (typeof this.language !== 'undefined') {
      toReturn['language'] = this.language;
    }
    if (typeof this.theming !== 'undefined' && this.theming !== null) {
      toReturn['theming'] = 'toApiJson' in this.theming ? this.theming.toApiJson() : this.theming;
    }
    if (typeof this.notificationsEnabled !== 'undefined') {
      toReturn['notificationsEnabled'] = this.notificationsEnabled;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.locationData !== 'undefined' && this.locationData !== null) {
      toReturn['locationData'] = 'toApiJson' in this.locationData ? this.locationData.toApiJson() : this.locationData;
    }
    if (typeof this.impersonateeUsername !== 'undefined') {
      toReturn['impersonateeUsername'] = this.impersonateeUsername;
    }
    if (typeof this.emailVerified !== 'undefined') {
      toReturn['emailVerified'] = this.emailVerified;
    }
    if (typeof this.userSwitcherData !== 'undefined' && this.userSwitcherData !== null) {
      toReturn['userSwitcherData'] = 'toApiJson' in this.userSwitcherData ? this.userSwitcherData.toApiJson() : this.userSwitcherData;
    }
    if (typeof this.partnerName !== 'undefined') {
      toReturn['partnerName'] = this.partnerName;
    }
    if (typeof this.businessAppUiTheme !== 'undefined') {
      toReturn['businessAppUiTheme'] = this.businessAppUiTheme;
    }
    return toReturn;
  }
}
class GetDefaultLocationRequest {
  static fromProto(proto) {
    let m = new GetDefaultLocationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetDefaultLocationResponse {
  static fromProto(proto) {
    let m = new GetDefaultLocationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    return toReturn;
  }
}
class GetLanguageRequest {
  static fromProto(proto) {
    let m = new GetLanguageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class GetLanguageResponse {
  static fromProto(proto) {
    let m = new GetLanguageResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.language !== 'undefined') {
      toReturn['language'] = this.language;
    }
    return toReturn;
  }
}
class GetLocationsRequest {
  static fromProto(proto) {
    let m = new GetLocationsRequest();
    m = Object.assign(m, proto);
    if (proto.accountGroups) {
      m.accountGroups = GetLocationsRequestAccountGroups.fromProto(proto.accountGroups);
    }
    if (proto.groups) {
      m.groups = GetLocationsRequestGroups.fromProto(proto.groups);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroups !== 'undefined' && this.accountGroups !== null) {
      toReturn['accountGroups'] = 'toApiJson' in this.accountGroups ? this.accountGroups.toApiJson() : this.accountGroups;
    }
    if (typeof this.groups !== 'undefined' && this.groups !== null) {
      toReturn['groups'] = 'toApiJson' in this.groups ? this.groups.toApiJson() : this.groups;
    }
    return toReturn;
  }
}
class GetLocationsResponse {
  static fromProto(proto) {
    let m = new GetLocationsResponse();
    m = Object.assign(m, proto);
    if (proto.locations) {
      m.locations = proto.locations.map(Location.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locations !== 'undefined' && this.locations !== null) {
      toReturn['locations'] = 'toApiJson' in this.locations ? this.locations.toApiJson() : this.locations;
    }
    return toReturn;
  }
}
class GetNavigationDataRequest {
  static fromProto(proto) {
    let m = new GetNavigationDataRequest();
    m = Object.assign(m, proto);
    if (proto.platformMode) {
      m.platformMode = enumStringToValue(PlatformMode, proto.platformMode);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.groupPath !== 'undefined') {
      toReturn['groupPath'] = this.groupPath;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.platformMode !== 'undefined') {
      toReturn['platformMode'] = this.platformMode;
    }
    return toReturn;
  }
}
class GetNavigationDataResponse {
  static fromProto(proto) {
    let m = new GetNavigationDataResponse();
    m = Object.assign(m, proto);
    if (proto.branding) {
      m.branding = Branding.fromProto(proto.branding);
    }
    if (proto.salesInfo) {
      m.salesInfo = SalesInfo.fromProto(proto.salesInfo);
    }
    if (proto.pinnedItems) {
      m.pinnedItems = proto.pinnedItems.map(PinnedItem.fromProto);
    }
    if (proto.associatedLocationIds) {
      m.associatedLocationIds = AssociatedLocationIDs.fromProto(proto.associatedLocationIds);
    }
    if (proto.dropdownItems) {
      m.dropdownItems = proto.dropdownItems.map(DropdownItem.fromProto);
    }
    if (proto.userView) {
      m.userView = enumStringToValue(UserViewType, proto.userView);
    }
    if (proto.retentionConfig) {
      m.retentionConfig = RetentionConfig.fromProto(proto.retentionConfig);
    }
    if (proto.totalLocations) {
      m.totalLocations = TotalLocations.fromProto(proto.totalLocations);
    }
    if (proto.navigationItems) {
      m.navigationItems = proto.navigationItems.map(SideNavigationItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.branding !== 'undefined' && this.branding !== null) {
      toReturn['branding'] = 'toApiJson' in this.branding ? this.branding.toApiJson() : this.branding;
    }
    if (typeof this.salesInfo !== 'undefined' && this.salesInfo !== null) {
      toReturn['salesInfo'] = 'toApiJson' in this.salesInfo ? this.salesInfo.toApiJson() : this.salesInfo;
    }
    if (typeof this.pinnedItems !== 'undefined' && this.pinnedItems !== null) {
      toReturn['pinnedItems'] = 'toApiJson' in this.pinnedItems ? this.pinnedItems.toApiJson() : this.pinnedItems;
    }
    if (typeof this.associatedLocationIds !== 'undefined' && this.associatedLocationIds !== null) {
      toReturn['associatedLocationIds'] = 'toApiJson' in this.associatedLocationIds ? this.associatedLocationIds.toApiJson() : this.associatedLocationIds;
    }
    if (typeof this.defaultLocation !== 'undefined') {
      toReturn['defaultLocation'] = this.defaultLocation;
    }
    if (typeof this.language !== 'undefined') {
      toReturn['language'] = this.language;
    }
    if (typeof this.dropdownItems !== 'undefined' && this.dropdownItems !== null) {
      toReturn['dropdownItems'] = 'toApiJson' in this.dropdownItems ? this.dropdownItems.toApiJson() : this.dropdownItems;
    }
    if (typeof this.currentBrandName !== 'undefined') {
      toReturn['currentBrandName'] = this.currentBrandName;
    }
    if (typeof this.userView !== 'undefined') {
      toReturn['userView'] = this.userView;
    }
    if (typeof this.retentionConfig !== 'undefined' && this.retentionConfig !== null) {
      toReturn['retentionConfig'] = 'toApiJson' in this.retentionConfig ? this.retentionConfig.toApiJson() : this.retentionConfig;
    }
    if (typeof this.totalLocations !== 'undefined' && this.totalLocations !== null) {
      toReturn['totalLocations'] = 'toApiJson' in this.totalLocations ? this.totalLocations.toApiJson() : this.totalLocations;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.businessAppBranding !== 'undefined') {
      toReturn['businessAppBranding'] = this.businessAppBranding;
    }
    if (typeof this.disableBusinessNav !== 'undefined') {
      toReturn['disableBusinessNav'] = this.disableBusinessNav;
    }
    if (typeof this.navigationItems !== 'undefined' && this.navigationItems !== null) {
      toReturn['navigationItems'] = 'toApiJson' in this.navigationItems ? this.navigationItems.toApiJson() : this.navigationItems;
    }
    if (typeof this.disableProductSwitcher !== 'undefined') {
      toReturn['disableProductSwitcher'] = this.disableProductSwitcher;
    }
    return toReturn;
  }
}
class GetPinsRequest {
  static fromProto(proto) {
    let m = new GetPinsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined') {
      toReturn['identifier'] = this.identifier;
    }
    return toReturn;
  }
}
class GetPinsResponse {
  static fromProto(proto) {
    let m = new GetPinsResponse();
    m = Object.assign(m, proto);
    if (proto.items) {
      m.items = proto.items.map(PinnedItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    return toReturn;
  }
}
class GetSalesInfoRequest {
  static fromProto(proto) {
    let m = new GetSalesInfoRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.groupPath !== 'undefined') {
      toReturn['groupPath'] = this.groupPath;
    }
    return toReturn;
  }
}
class GetSalesInfoResponse {
  static fromProto(proto) {
    let m = new GetSalesInfoResponse();
    m = Object.assign(m, proto);
    if (proto.salesInfo) {
      m.salesInfo = SalesInfo.fromProto(proto.salesInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesInfo !== 'undefined' && this.salesInfo !== null) {
      toReturn['salesInfo'] = 'toApiJson' in this.salesInfo ? this.salesInfo.toApiJson() : this.salesInfo;
    }
    return toReturn;
  }
}
class GetLocationsRequestGroups {
  static fromProto(proto) {
    let m = new GetLocationsRequestGroups();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.groupPaths !== 'undefined') {
      toReturn['groupPaths'] = this.groupPaths;
    }
    return toReturn;
  }
}
class ListElevatedLocationsRequest {
  static fromProto(proto) {
    let m = new ListElevatedLocationsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.search !== 'undefined') {
      toReturn['search'] = this.search;
    }
    if (typeof this.accountGroups !== 'undefined') {
      toReturn['accountGroups'] = this.accountGroups;
    }
    if (typeof this.brands !== 'undefined') {
      toReturn['brands'] = this.brands;
    }
    return toReturn;
  }
}
class ListElevatedLocationsResponse {
  static fromProto(proto) {
    let m = new ListElevatedLocationsResponse();
    m = Object.assign(m, proto);
    if (proto.locations) {
      m.locations = proto.locations.map(Location.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locations !== 'undefined' && this.locations !== null) {
      toReturn['locations'] = 'toApiJson' in this.locations ? this.locations.toApiJson() : this.locations;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListLocationsRequest {
  static fromProto(proto) {
    let m = new ListLocationsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.search !== 'undefined') {
      toReturn['search'] = this.search;
    }
    if (typeof this.includeAccountGroups !== 'undefined') {
      toReturn['includeAccountGroups'] = this.includeAccountGroups;
    }
    if (typeof this.includeBrands !== 'undefined') {
      toReturn['includeBrands'] = this.includeBrands;
    }
    return toReturn;
  }
}
class ListLocationsResponse {
  static fromProto(proto) {
    let m = new ListLocationsResponse();
    m = Object.assign(m, proto);
    if (proto.locations) {
      m.locations = proto.locations.map(Location.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.locations !== 'undefined' && this.locations !== null) {
      toReturn['locations'] = 'toApiJson' in this.locations ? this.locations.toApiJson() : this.locations;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class Location {
  static fromProto(proto) {
    let m = new Location();
    m = Object.assign(m, proto);
    if (proto.accountGroup) {
      m.accountGroup = AccountGroup.fromProto(proto.accountGroup);
    }
    if (proto.brand) {
      m.brand = Brand.fromProto(proto.brand);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroup !== 'undefined' && this.accountGroup !== null) {
      toReturn['accountGroup'] = 'toApiJson' in this.accountGroup ? this.accountGroup.toApiJson() : this.accountGroup;
    }
    if (typeof this.brand !== 'undefined' && this.brand !== null) {
      toReturn['brand'] = 'toApiJson' in this.brand ? this.brand.toApiJson() : this.brand;
    }
    return toReturn;
  }
}
class LocationData {
  static fromProto(proto) {
    let m = new LocationData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    return toReturn;
  }
}
class PinnedItem {
  static fromProto(proto) {
    let m = new PinnedItem();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.navigationId !== 'undefined') {
      toReturn['navigationId'] = this.navigationId;
    }
    return toReturn;
  }
}
class RetentionConfig {
  static fromProto(proto) {
    let m = new RetentionConfig();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cancellationNotificationEmail !== 'undefined') {
      toReturn['cancellationNotificationEmail'] = this.cancellationNotificationEmail;
    }
    return toReturn;
  }
}
class SalesContact {
  static fromProto(proto) {
    let m = new SalesContact();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.photoUrlSecure !== 'undefined') {
      toReturn['photoUrlSecure'] = this.photoUrlSecure;
    }
    if (typeof this.jobTitle !== 'undefined') {
      toReturn['jobTitle'] = this.jobTitle;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.meetingBookingUrl !== 'undefined') {
      toReturn['meetingBookingUrl'] = this.meetingBookingUrl;
    }
    return toReturn;
  }
}
class SalesInfo {
  static fromProto(proto) {
    let m = new SalesInfo();
    m = Object.assign(m, proto);
    if (proto.salesContact) {
      m.salesContact = SalesContact.fromProto(proto.salesContact);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.marketName !== 'undefined') {
      toReturn['marketName'] = this.marketName;
    }
    if (typeof this.salesContact !== 'undefined' && this.salesContact !== null) {
      toReturn['salesContact'] = 'toApiJson' in this.salesContact ? this.salesContact.toApiJson() : this.salesContact;
    }
    return toReturn;
  }
}
class SetDefaultLocationRequest {
  static fromProto(proto) {
    let m = new SetDefaultLocationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.groupId !== 'undefined') {
      toReturn['groupId'] = this.groupId;
    }
    return toReturn;
  }
}
class SetLanguageRequest {
  static fromProto(proto) {
    let m = new SetLanguageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.language !== 'undefined') {
      toReturn['language'] = this.language;
    }
    return toReturn;
  }
}
class SetPinsRequest {
  static fromProto(proto) {
    let m = new SetPinsRequest();
    m = Object.assign(m, proto);
    if (proto.items) {
      m.items = proto.items.map(PinnedItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined') {
      toReturn['identifier'] = this.identifier;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn['items'] = 'toApiJson' in this.items ? this.items.toApiJson() : this.items;
    }
    return toReturn;
  }
}
class SideNavigationContainer {
  static fromProto(proto) {
    let m = new SideNavigationContainer();
    m = Object.assign(m, proto);
    if (proto.sideNavigationItems) {
      m.sideNavigationItems = proto.sideNavigationItems.map(SideNavigationItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.translationId !== 'undefined') {
      toReturn['translationId'] = this.translationId;
    }
    if (typeof this.sideNavigationItems !== 'undefined' && this.sideNavigationItems !== null) {
      toReturn['sideNavigationItems'] = 'toApiJson' in this.sideNavigationItems ? this.sideNavigationItems.toApiJson() : this.sideNavigationItems;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.logoUrl !== 'undefined') {
      toReturn['logoUrl'] = this.logoUrl;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.showIcon !== 'undefined') {
      toReturn['showIcon'] = this.showIcon;
    }
    if (typeof this.chipContent !== 'undefined') {
      toReturn['chipContent'] = this.chipContent;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.pinnable !== 'undefined') {
      toReturn['pinnable'] = this.pinnable;
    }
    if (typeof this.navigationId !== 'undefined') {
      toReturn['navigationId'] = this.navigationId;
    }
    return toReturn;
  }
}
class SideNavigationItem {
  static fromProto(proto) {
    let m = new SideNavigationItem();
    m = Object.assign(m, proto);
    if (proto.sideNavigationSection) {
      m.sideNavigationSection = SideNavigationSection.fromProto(proto.sideNavigationSection);
    }
    if (proto.sideNavigationContainer) {
      m.sideNavigationContainer = SideNavigationContainer.fromProto(proto.sideNavigationContainer);
    }
    if (proto.sideNavigationLink) {
      m.sideNavigationLink = SideNavigationLink.fromProto(proto.sideNavigationLink);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sideNavigationSection !== 'undefined' && this.sideNavigationSection !== null) {
      toReturn['sideNavigationSection'] = 'toApiJson' in this.sideNavigationSection ? this.sideNavigationSection.toApiJson() : this.sideNavigationSection;
    }
    if (typeof this.sideNavigationContainer !== 'undefined' && this.sideNavigationContainer !== null) {
      toReturn['sideNavigationContainer'] = 'toApiJson' in this.sideNavigationContainer ? this.sideNavigationContainer.toApiJson() : this.sideNavigationContainer;
    }
    if (typeof this.sideNavigationLink !== 'undefined' && this.sideNavigationLink !== null) {
      toReturn['sideNavigationLink'] = 'toApiJson' in this.sideNavigationLink ? this.sideNavigationLink.toApiJson() : this.sideNavigationLink;
    }
    return toReturn;
  }
}
class SideNavigationLink {
  static fromProto(proto) {
    let m = new SideNavigationLink();
    m = Object.assign(m, proto);
    if (proto.subLinks) {
      m.subLinks = proto.subLinks.map(SideNavigationLink.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.navigationId !== 'undefined') {
      toReturn['navigationId'] = this.navigationId;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.path !== 'undefined') {
      toReturn['path'] = this.path;
    }
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn['serviceProviderId'] = this.serviceProviderId;
    }
    if (typeof this.logoUrl !== 'undefined') {
      toReturn['logoUrl'] = this.logoUrl;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.translationId !== 'undefined') {
      toReturn['translationId'] = this.translationId;
    }
    if (typeof this.external !== 'undefined') {
      toReturn['external'] = this.external;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.showIcon !== 'undefined') {
      toReturn['showIcon'] = this.showIcon;
    }
    if (typeof this.pinnable !== 'undefined') {
      toReturn['pinnable'] = this.pinnable;
    }
    if (typeof this.chipContent !== 'undefined') {
      toReturn['chipContent'] = this.chipContent;
    }
    if (typeof this.isTrial !== 'undefined') {
      toReturn['isTrial'] = this.isTrial;
    }
    if (typeof this.userRequired !== 'undefined') {
      toReturn['userRequired'] = this.userRequired;
    }
    if (typeof this.openInNewTab !== 'undefined') {
      toReturn['openInNewTab'] = this.openInNewTab;
    }
    if (typeof this.subLinks !== 'undefined' && this.subLinks !== null) {
      toReturn['subLinks'] = 'toApiJson' in this.subLinks ? this.subLinks.toApiJson() : this.subLinks;
    }
    if (typeof this.launchUrl !== 'undefined') {
      toReturn['launchUrl'] = this.launchUrl;
    }
    if (typeof this.descriptionTranslationId !== 'undefined') {
      toReturn['descriptionTranslationId'] = this.descriptionTranslationId;
    }
    return toReturn;
  }
}
class SideNavigationSection {
  static fromProto(proto) {
    let m = new SideNavigationSection();
    m = Object.assign(m, proto);
    if (proto.sideNavigationItems) {
      m.sideNavigationItems = proto.sideNavigationItems.map(SideNavigationItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.translationId !== 'undefined') {
      toReturn['translationId'] = this.translationId;
    }
    if (typeof this.sideNavigationItems !== 'undefined' && this.sideNavigationItems !== null) {
      toReturn['sideNavigationItems'] = 'toApiJson' in this.sideNavigationItems ? this.sideNavigationItems.toApiJson() : this.sideNavigationItems;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.chipContent !== 'undefined') {
      toReturn['chipContent'] = this.chipContent;
    }
    return toReturn;
  }
}
class Theming {
  static fromProto(proto) {
    let m = new Theming();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.primaryColor !== 'undefined') {
      toReturn['primaryColor'] = this.primaryColor;
    }
    if (typeof this.primaryHoverColor !== 'undefined') {
      toReturn['primaryHoverColor'] = this.primaryHoverColor;
    }
    if (typeof this.primaryActiveColor !== 'undefined') {
      toReturn['primaryActiveColor'] = this.primaryActiveColor;
    }
    if (typeof this.secondaryColor !== 'undefined') {
      toReturn['secondaryColor'] = this.secondaryColor;
    }
    if (typeof this.secondaryHoverColor !== 'undefined') {
      toReturn['secondaryHoverColor'] = this.secondaryHoverColor;
    }
    if (typeof this.secondaryActiveColor !== 'undefined') {
      toReturn['secondaryActiveColor'] = this.secondaryActiveColor;
    }
    if (typeof this.fontColor !== 'undefined') {
      toReturn['fontColor'] = this.fontColor;
    }
    if (typeof this.fontDisabledColor !== 'undefined') {
      toReturn['fontDisabledColor'] = this.fontDisabledColor;
    }
    if (typeof this.accentsColor !== 'undefined') {
      toReturn['accentsColor'] = this.accentsColor;
    }
    if (typeof this.accentsActiveColor !== 'undefined') {
      toReturn['accentsActiveColor'] = this.accentsActiveColor;
    }
    if (typeof this.focusColor !== 'undefined') {
      toReturn['focusColor'] = this.focusColor;
    }
    if (typeof this.borderColor !== 'undefined') {
      toReturn['borderColor'] = this.borderColor;
    }
    return toReturn;
  }
}
class TotalLocations {
  static fromProto(proto) {
    let m = new TotalLocations();
    m = Object.assign(m, proto);
    if (proto.accounts) {
      m.accounts = parseInt(proto.accounts, 10);
    }
    if (proto.brands) {
      m.brands = parseInt(proto.brands, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accounts !== 'undefined') {
      toReturn['accounts'] = this.accounts;
    }
    if (typeof this.brands !== 'undefined') {
      toReturn['brands'] = this.brands;
    }
    return toReturn;
  }
}
class UserNavigationItem {
  static fromProto(proto) {
    let m = new UserNavigationItem();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.routeId !== 'undefined') {
      toReturn['routeId'] = this.routeId;
    }
    return toReturn;
  }
}
class UserSwitcherData {
  static fromProto(proto) {
    let m = new UserSwitcherData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.partnerName !== 'undefined') {
      toReturn['partnerName'] = this.partnerName;
    }
    if (typeof this.entryUrl !== 'undefined') {
      toReturn['entryUrl'] = this.entryUrl;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AtlasApiService = /*#__PURE__*/(() => {
  class AtlasApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getData(r) {
      const request = r.toApiJson ? r : new GetDataRequest(r);
      return this.http.post(this._host + "/atlas.v1.Atlas/GetData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDataResponse.fromProto(resp)));
    }
    getNavigationData(r) {
      const request = r.toApiJson ? r : new GetNavigationDataRequest(r);
      return this.http.post(this._host + "/atlas.v1.Atlas/GetNavigationData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetNavigationDataResponse.fromProto(resp)));
    }
    getSalesInfo(r) {
      const request = r.toApiJson ? r : new GetSalesInfoRequest(r);
      return this.http.post(this._host + "/atlas.v1.Atlas/GetSalesInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSalesInfoResponse.fromProto(resp)));
    }
    getLocations(r) {
      const request = r.toApiJson ? r : new GetLocationsRequest(r);
      return this.http.post(this._host + "/atlas.v1.Atlas/GetLocations", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLocationsResponse.fromProto(resp)));
    }
    listElevatedLocations(r) {
      const request = r.toApiJson ? r : new ListElevatedLocationsRequest(r);
      return this.http.post(this._host + "/atlas.v1.Atlas/ListElevatedLocations", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListElevatedLocationsResponse.fromProto(resp)));
    }
    listLocations(r) {
      const request = r.toApiJson ? r : new ListLocationsRequest(r);
      return this.http.post(this._host + "/atlas.v1.Atlas/ListLocations", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListLocationsResponse.fromProto(resp)));
    }
    contactUs(r) {
      const request = r.toApiJson ? r : new ContactUsRequest(r);
      return this.http.post(this._host + "/atlas.v1.Atlas/ContactUs", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setDefaultLocation(r) {
      const request = r.toApiJson ? r : new SetDefaultLocationRequest(r);
      return this.http.post(this._host + "/atlas.v1.Atlas/SetDefaultLocation", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getDefaultLocation(r) {
      const request = r.toApiJson ? r : new GetDefaultLocationRequest(r);
      return this.http.post(this._host + "/atlas.v1.Atlas/GetDefaultLocation", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDefaultLocationResponse.fromProto(resp)));
    }
  }
  AtlasApiService.ɵfac = function AtlasApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AtlasApiService)();
  };
  AtlasApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AtlasApiService,
    factory: AtlasApiService.ɵfac,
    providedIn: 'root'
  });
  return AtlasApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let LanguagesApiService = /*#__PURE__*/(() => {
  class LanguagesApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    setLanguage(r) {
      const request = r.toApiJson ? r : new SetLanguageRequest(r);
      return this.http.post(this._host + "/atlas.v1.Languages/SetLanguage", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getLanguage(r) {
      const request = r.toApiJson ? r : new GetLanguageRequest(r);
      return this.http.post(this._host + "/atlas.v1.Languages/GetLanguage", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetLanguageResponse.fromProto(resp)));
    }
  }
  LanguagesApiService.ɵfac = function LanguagesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || LanguagesApiService)();
  };
  LanguagesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: LanguagesApiService,
    factory: LanguagesApiService.ɵfac,
    providedIn: 'root'
  });
  return LanguagesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PinsApiService = /*#__PURE__*/(() => {
  class PinsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    setPins(r) {
      const request = r.toApiJson ? r : new SetPinsRequest(r);
      return this.http.post(this._host + "/atlas.v1.Pins/SetPins", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getPins(r) {
      const request = r.toApiJson ? r : new GetPinsRequest(r);
      return this.http.post(this._host + "/atlas.v1.Pins/GetPins", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPinsResponse.fromProto(resp)));
    }
  }
  PinsApiService.ɵfac = function PinsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PinsApiService)();
  };
  PinsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PinsApiService,
    factory: PinsApiService.ɵfac,
    providedIn: 'root'
  });
  return PinsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AccountGroup, AssociatedLocationIDs, AtlasApiService, Brand, Branding, CenterNavigationItem, ContactUsRequest, DropdownItem, ExitLinkConfiguration, GetDataRequest, GetDataResponse, GetDefaultLocationRequest, GetDefaultLocationResponse, GetLanguageRequest, GetLanguageResponse, GetLocationsRequest, GetLocationsRequestAccountGroups, GetLocationsRequestGroups, GetLocationsResponse, GetNavigationDataRequest, GetNavigationDataResponse, GetPinsRequest, GetPinsResponse, GetSalesInfoRequest, GetSalesInfoResponse, HostService, LanguagesApiService, ListElevatedLocationsRequest, ListElevatedLocationsResponse, ListLocationsRequest, ListLocationsResponse, Location, LocationData, PinnedItem, PinsApiService, PlatformMode, RetentionConfig, SalesContact, SalesInfo, SetDefaultLocationRequest, SetLanguageRequest, SetPinsRequest, SideNavigationContainer, SideNavigationItem, SideNavigationLink, SideNavigationSection, Theming, TotalLocations, UITheme, UserNavigationItem, UserSwitcherData, UserViewType };
